import React from 'react';
import { permissionButton } from '../../util/Util';
import { useSelector } from 'react-redux';

export default function SecondaryButton(props) {
    const { permission } = useSelector((state) => state.auth);
    return (
        <button className={`w-[154px] h-[44px] ${props.actions ?
            permissionButton(permission, props.actions, props.menu, props.parent) === true
              ? ""
              : "hidden" : ""
          } ${props.disabled ? "text-gray-100 border-[2px] border-gray-100 cursor-not-allowed" : "text-[#CF0000] border-[2px] border-[#CF0000]"}  bg-white-100 text-xl flex items-center justify-evenly rounded-md ${props.styles}`} onClick={props.action} disabled={props.disabled}>
            {props.prefixIcon !== undefined ? props.prefixIcon : null}
            {props.text}
            {props.suffixIcon !== undefined ? props.suffixIcon : null}
        </button>
    );
}